import PropTypes from 'prop-types';

const DocumentUploadType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  created_at: PropTypes.string.isRequired,
  document_name: PropTypes.string.isRequired,
  document_type: PropTypes.string.isRequired,
  expiring_download_url: PropTypes.string.isRequired,
  not_use: PropTypes.bool.isRequired,
  user_name: PropTypes.string.isRequired,
});

export default DocumentUploadType;



// WEBPACK FOOTER //
// ./client/app/shared/types/documentUpload.js